import { render, staticRenderFns } from "./GroupUserAssign.vue?vue&type=template&id=32120628&scoped=true&"
import script from "./GroupUserAssign.vue?vue&type=script&lang=js&"
export * from "./GroupUserAssign.vue?vue&type=script&lang=js&"
import style0 from "./GroupUserAssign.vue?vue&type=style&index=0&id=32120628&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32120628",
  null
  
)

export default component.exports